import React from 'react';
import { Award } from 'lucide-react';
import { useT } from '../services/i18n';

export const TOP_RATING = 4.5;
export const TOP_REVIEWS = 5;
export const isTopRated = (p) => !!p && Number(p.rating) >= TOP_RATING && Number(p.reviews) >= TOP_REVIEWS;

/** « Recommandé par nos clients » — products rated ≥ 4.5/5 with ≥ 5 verified reviews. */
const TopProductBadge = ({ product, size = 'sm', className = '', testId }) => {
  const { t } = useT();
  if (!isTopRated(product)) return null;
  const cls = size === 'lg' ? 'text-xs px-3 py-1 gap-1.5' : 'text-[11px] px-2 py-0.5 gap-1';
  return (
    <span className={`inline-flex items-center font-semibold rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200 ${cls} ${className}`} data-testid={testId || `top-product-badge-${product.id}`} title={t('product.topBadgeHint', { r: Number(product.rating).toFixed(1), n: product.reviews })}>
      <Award size={size === 'lg' ? 14 : 11} /> {t('product.topBadge')}
    </span>
  );
};

export default TopProductBadge;
